// src/components/analytics/GoogleAnalytics.tsx
"use client";

import Script from "next/script";

interface GoogleAnalyticsProps {
  gaId: string;
}

export default function GoogleAnalytics({ gaId }: GoogleAnalyticsProps) {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
        // Opcional: Preload para mejor performance
        // rel="preload"
      />
      
      <Script id="google-analytics-config" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          
          // Configuración optimizada
          gtag('config', '${gaId}', {
            page_path: window.location.pathname,
            // Optimizaciones de performance
            transport_type: 'beacon',
            // No enviar ciertos datos que pueden ralentizar
            allow_google_signals: false,
            allow_ad_personalization_signals: false,
            // Cache para mejorar velocidad
            use_cache: true
          });
          
          // Prevenir tracking en desarrollo
          if (window.location.hostname === 'localhost') {
            window['ga-disable-${gaId}'] = true;
          }
        `}
      </Script>
    </>
  );
}